export const defaultLeaseColumns = [
  'ownerName',
  'propertyType',
  'propertySubtypeLabel',
  'sizeLabel',
  'numberOfUnits',
  'leaseRateLabel',
  'leaseDate',
  'leaseExecutionDate',
  'leaseExpirationDate',
  'tenantString'
];

export const defaultSaleColumns = [
  'ownerName',
  'propertyType',
  'propertySubtypeLabel',
  'price',
  'saleDate',
  'buyerName',
  'sellerName'
];

export const initialState = {
  addressFilter: {
    buildingNumber: '',
    cities: [],
    currentCity: '',
    market: '',
    microMarket: '',
    state: '',
    street: '',
    subMarket: '',
    zip: ''
  },
  propertyFilter: {
    lotUnits: 'sf',
    apnNumber: '',
    maxAvailableSF: '',
    maxBuildingSize: '',
    maxCeilingHeight: '',
    maxLotSize: '',
    maxNumUnits: '',
    maxYearBuilt: '',
    minAvailableSF: '',
    minBuildingSize: '',
    minCeilingHeight: '',
    minLotSize: '',
    minNumUnits: '',
    minYearBuilt: '',
    minNumKeys: '',
    maxNumKeys: ''
  },
  saleFilter: {
    maxSalesPrice: '',
    minSalesPrice: '',
    maxSalesDate: '',
    minSalesDate: '',
    maxSfPrice: '',
    minSfPrice: '',
    maxCapRate: '',
    minCapRate: ''
  },
  leaseFilter: {
    leaseSpaceType: '',
    leaseType: '',
    leaseRateUnits: 'dollars_per_month',
    maxLeasePrice: '',
    minLeasePrice: '',
    maxLeaseDate: '',
    minLeaseDate: '',
    maxLeaseSize: '',
    minLeaseSize: '',
    maxUnitPrice: '',
    minUnitPrice: ''
  },
  industrialFilter: {
    availableRailProvider: '',
    driveThroughAccess: false,
    lotBorderType: '',
    lotStabilization: '',
    maxAcresStabilized: '',
    maxBridgeCraneSpan: '',
    maxJibCraneSpan: '',
    maxNumBridgeCranes: '',
    maxNumJibCranes: '',
    maxReadyCapacity: '',
    maxReadySpan: '',
    minAcresStabilized: '',
    minBridgeCraneSpan: '',
    minJibCraneSpan: '',
    minNumBridgeCranes: '',
    minNumJibCranes: '',
    minReadyCapacity: '',
    minReadySpan: '',
    ready: false,
    served: false,
    servedRailProvider: ''
  },
  multifamilyFilter: {
    maxBeds: '',
    maxBaths: '',
    maxSize: '',
    maxRent: '',
    maxMarketRent: '',
    minBeds: '',
    minBaths: '',
    minSize: '',
    minRent: '',
    minMarketRent: ''
  },
  availabilities: [],
  assetClasses: [],
  buildingClasses: [],
  investmentTypes: [],
  searchText: '',
  propertyPage: 1
};
